/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Distribution_NowInputs */

const en_us2_progress_report_distribution_now = /** @type {(inputs: Progress_Report_Distribution_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Now`)
};

const pt_br2_progress_report_distribution_now = /** @type {(inputs: Progress_Report_Distribution_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora`)
};

const es_419_progress_report_distribution_now = /** @type {(inputs: Progress_Report_Distribution_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora`)
};

const pt_pt2_progress_report_distribution_now = /** @type {(inputs: Progress_Report_Distribution_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora`)
};

const fr_fr2_progress_report_distribution_now = /** @type {(inputs: Progress_Report_Distribution_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintenant`)
};

const de_de2_progress_report_distribution_now = /** @type {(inputs: Progress_Report_Distribution_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt`)
};

const it_it2_progress_report_distribution_now = /** @type {(inputs: Progress_Report_Distribution_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ora`)
};

/**
* | output |
* | --- |
* | "Now" |
*
* @param {Progress_Report_Distribution_NowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_distribution_now = /** @type {((inputs?: Progress_Report_Distribution_NowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Distribution_NowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_distribution_now(inputs)
	if (locale === "es-419") return es_419_progress_report_distribution_now(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_distribution_now(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_distribution_now(inputs)
	if (locale === "de-DE") return de_de2_progress_report_distribution_now(inputs)
	if (locale === "it-IT") return it_it2_progress_report_distribution_now(inputs)
	return en_us2_progress_report_distribution_now(inputs)
});
export { progress_report_distribution_now as "progress-report.distribution_now" }